import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import DetalhesDoPedidoFluxoViewModel from "@/shared/view-models/DetalhesDoPedidoFluxoViewModel";
import { defineComponent } from "vue";
import Tools from "@/shared/services/tools";
import PedidoEmAndamentoPDF from "@/pages/Pedidos/PedidoEmAndamento/components/DetalhesPedidoEmAndamento/PDF/PedidoEmAndamentoPDF.vue";


const name = 'ParcelasPedidoExpedidoFaturado'

export default defineComponent({
  name,

  components: {
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    PedidoEmAndamentoPDF
  },

  props: {},

  mounted() {
    this.getDetalhesDoPedido();
    this.GetParcelas();
  },

  updated() { },

  data() {
    return {
      parcelasInfo: [],
      detalhesDoPedidoFluxo : new DetalhesDoPedidoFluxoViewModel(),
      numeroParcela: '',
      codigoExterno: '',
      codigo: '',
      tipoPedidoTexto: '',
      curvaClienteTexto: '',
      nomeEmpresa: '',
      nomeRepresentante: '',
      nomeFantasia: '',
      cnpj: '',
      dataBasePedidoParcela: '',
      codigoExternoCliente:'',
      componentePedidoParcelaArray: [],
      indicadorTexto:'',
      PedidoId: null,
      renderiza: false,
      executarvisualizacao: 0,
      podeGerarPdf: false,
    }
  },

  methods: {

    formataDecimal(valor){
      return Tools.valorDecimalFormatado(valor)
    },

    formataMonetario(valor){ 
      return Tools.valorMonetario4Digitos(valor)
    },
    voltar() {
      this.$router.push(`/pedido-expedido-faturado-fluxo/${this.$route.params.id}/detalhes-pedido-expedido-faturado`);
    },

    getDetalhesDoPedido() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.detalhesDoPedidoFluxo, Tools.captalizeKeys(response.data.data))
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },


    GetParcelas() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetParcelasPedidosEmAndamento/${this.$route.params.id}`,
      })
        .then((response) => {
          this.parcelasInfo = response.data.data;
          this.numeroParcela = response.data.data.numeroParcela;
          this.pedidoParcelaId = response.data.data.pedidoParcelaId;
          this.indicadorTexto = response.data.data.indicadorTexto;
        })
        .catch(() => {
        });
    },


    notasFiscaisRota() {
      this.$router.push(`/notas-fiscais/${this.parcelasInfo[0].codigoExterno}`)
    },

    observacoesRota(pedidoParcelaId, numeroParcela) {
      // this.mitt.emit('apareceTab', 4)
      this.$router.push(`/pedido-expedido-faturado-fluxo/${pedidoParcelaId}/${numeroParcela}/observacoes-pedido-expedido-faturado`)
    },

    instrucoesCarregamentoRota(pedidoParcelaId, numeroParcela) {
      // this.mitt.emit('apareceTab', 5)
      this.$router.push(`/pedido-expedido-faturado-fluxo/${pedidoParcelaId}/${numeroParcela}/instrucoes-carregamento-pedido-expedido-faturado`)
    },

    historicoRota(pedidoParcelaId,numeroParcela) {
      // this.mitt.emit('apareceTab', 1)
      this.$router.push(`/pedido-expedido-faturado-fluxo/${pedidoParcelaId}/${numeroParcela}/historico-pedido-expedido-faturado`)
    },


    imprimir() {  
      this.renderiza = true
      this.PedidoId = this.$route.params.id
      
      if(this.podeGerarPdf) {
        this.executarvisualizacao++
      }
    },

    gerarPdf() {
      setTimeout(() => {
        this.executarvisualizacao++
      }, "500");
    },
  },

  computed: {}
});